//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import searchFilterSocialSearchStateTemplate from '@legacy-components/filters/search-filter-social-search-state.html';

(function() {
  const curalate = angular.module('curalate');

  curalate.component('searchFilterSocialSearchState', {
    template: searchFilterSocialSearchStateTemplate,
    controllerAs: '$contentSearchState',
    controller: [
      '$scope',
      '$rootScope',
      '$modal',
      'ContentSearchTypes',
      function(
                $scope,
                $rootScope,
                $modal,
                ContentSearchTypes,
            ) {
        $scope.model = {
          stateOptions: [
                        { label: 'Posts match ALL search terms', value: ContentSearchTypes.STATE.ALL },
                        { label: 'Posts match ANY search terms', value: ContentSearchTypes.STATE.ANY },
          ],
        };
      },
    ],
  });
})();
